// extracted by mini-css-extract-plugin
export default {"checkbox-text":"style_checkbox-text__lW9Od","checkbox-check":"style_checkbox-check__qFzTI"};